import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=6d10872d&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
import style0 from "../styles/salon-site.css?vue&type=style&index=0&id=6d10872d&prod&scoped=true&lang=css&external"
import style1 from "./HelloWorld.vue?vue&type=style&index=1&id=6d10872d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10872d",
  null
  
)

export default component.exports